const t = {
  xs: "100",
  sm: "100",
  md: "200",
  lg: "200",
  xl: "300"
}, s = {
  SPLIT_BUTTON_ICON_SIZES: t
};
export {
  t as SPLIT_BUTTON_ICON_SIZES,
  s as default
};
//# sourceMappingURL=split-button-constants.js.map
